export enum AlignContactSection {
  VERTICAL = 'Vertical',
  HORIZONTAL = 'Horizantal',
}
